import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  user: "",
  verifyData: { otp: "", userId: "" }
};

const authSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    userRegistration: (state, action) => {
      state.token = action.payload.token;
    },
    setVerifyData: (state, action) => {
      state.verifyData = action.payload;
    },
    userLogin: (
      state,
      action
    ) => {

      state.token = action.payload.acessToken;
      state.user = action.payload.user;
    },
    userLogout: (state) => {
      state.token = "";
      state.user = "";
    },
    updateUser: (state, action) => {

      state.user = { ...state.user, ...action.payload };
    },
  },
});

export const { userRegistration, userLogin, userLogout, setVerifyData, updateUser } = authSlice.actions;
export default authSlice.reducer;

export const userInfo = state => state.Auth?.user
